import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// Constants
import { TRANSACTION_SORT } from "constants/transactions";

// Types
import {
  TransactionType,
  TransactionSortType,
  MethodType,
  TRANSACTION_STATUS,
} from "types/Transaction";

type TransactionState = {
  transactionListDeposit: TransactionType[] | [];
  transactionListWithdraw: TransactionType[] | [];
  isFilterReseted: boolean;
  sort: TransactionSortType;
};

const initialState: TransactionState = {
  transactionListDeposit: [],
  transactionListWithdraw: [],
  isFilterReseted: false,
  sort: TRANSACTION_SORT[0],
};

export const transactionSlice = createSlice({
  name: "transaction",
  initialState,
  reducers: {
    getDepositTransaction(state, action: PayloadAction<TransactionType[]>) {
      state.transactionListDeposit = action.payload.map((transaction) => {
        const status = transaction.status.toLowerCase() as TRANSACTION_STATUS;
        // const paymentMethod = getPaymentMethodByCode(transaction.method.code);
        const name = transaction.method.name ?? "";
        const logo = transaction.method.logo ?? "";

        const methodWithLogo: MethodType = {
          ...transaction.method,
          name,
          logo,
        };

        const type =
          transaction.type.toLowerCase() === "deposit"
            ? "profile.navigation.deposit"
            : "profile.navigation.withdraw";

        return {
          ...transaction,
          status,
          method: methodWithLogo,
          type,
        };
      });
    },

    getWithdrawTransaction(state, action: PayloadAction<TransactionType[]>) {
      state.transactionListWithdraw = action.payload.map((transaction) => {
        // const paymentMethod = getPaymentMethodByCode(transaction.method.code);
        const status = transaction.status.toLowerCase() as TRANSACTION_STATUS;
        const name = transaction.method.name ?? "";
        const logo = transaction.method.logo ?? "";
        const methodWithLogo: MethodType = {
          ...transaction.method,
          name,
          logo,
        };

        const type =
          transaction.type.toLowerCase() === "deposit"
            ? "profile.navigation.deposit"
            : "profile.navigation.withdraw";

        return {
          ...transaction,
          method: methodWithLogo,
          type,
          status,
        };
      });
    },
    setSort(state, action: PayloadAction<TransactionSortType>) {
      state.isFilterReseted = false;
      state.sort = action.payload;
    },
  },
});

export const { getDepositTransaction, getWithdrawTransaction, setSort } =
  transactionSlice.actions;

export default transactionSlice.reducer;
